import { MortgageCalculator } from "../Apps/MortgageCalculator"

function AppMortgageCalculator() {

  return (
    <MortgageCalculator />
  )
}

export default AppMortgageCalculator

